// extracted by mini-css-extract-plugin
module.exports = {"title":"TimeWindow_title__1Kere","timeWindowText":"TimeWindow_timeWindowText__2G7Gk","rescheduleButton":"TimeWindow_rescheduleButton__2mGUn"};